// API Configuration
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

// API Endpoints
export const API_ENDPOINTS = {
  // Authentication
  LOGIN: '/auth/login',
  LOGOUT: '/auth/logout',
  
  // Companies
  COMPANIES: '/companies',
  COMPANIES_SEARCH: '/companies/search',
  
  // Users
  USERS: '/users',
  USERS_BY_COMPANY: '/users/company',
  USERS_EMPLOYEES: '/users/employees',
  
  // Customers
  CUSTOMERS: '/customers',
  CUSTOMERS_SEARCH: '/customers/search',
  
  // Items
  ITEMS: '/items',
  ITEMS_SEARCH: '/items/search',
  
  // Debts
  DEBTS: '/debts',
  DEBTS_BY_CUSTOMER: '/debts/customer',
  DEBTS_CUSTOMER_TOTAL: '/debts/customer/total',

  // Company expenses
  EXPENSES: '/expenses',
} as const;

// Local Storage Keys
export const STORAGE_KEYS = {
  TOKEN: 'veresiye_token',
  USER: 'veresiye_user',
} as const;

// Application Constants
export const APP_CONFIG = {
  NAME: 'Veresiye',
  DESCRIPTION: 'Stock, CRM and Debt Tracking System',
  VERSION: '1.0.0',
  WHATSAPP_NUMBER: process.env.REACT_APP_WHATSAPP_NUMBER || '+905551234567', // Configure via REACT_APP_WHATSAPP_NUMBER
} as const;

// Role-based permissions
export const ROLE_PERMISSIONS = {
  SUPER_ADMIN: [
    'companies.read',
    'companies.write',
    'companies.delete',
    'users.read',
    'users.write',
    'users.delete',
    'customers.read',
    'items.read',
    'sales.read',
    'debts.read',
    'payments.read',
    'expenses.read',
  ],
  COMPANY_ADMIN: [
    'users.read',
    'users.write',
    'users.delete',
    'customers.read',
    'customers.write',
    'customers.delete',
    'items.read',
    'items.write',
    'items.delete',
    'sales.read',
    'sales.write',
    'sales.delete',
    'debts.read',
    'debts.write',
    'debts.delete',
    'payments.read',
    'payments.write',
    'expenses.read',
    'expenses.write',
    'expenses.delete',
  ],
  EMPLOYEE: [
    'customers.read',
    'items.read',
    'sales.read',
    'sales.write',
    'debts.read',
    'debts.write',
    'payments.read',
    'payments.write',
  ],
} as const;

// Navigation menu items
export const NAVIGATION_ITEMS = {
  SUPER_ADMIN: [
    { label: 'Dashboard', path: '/dashboard', icon: 'dashboard' },
    { label: 'Reports', path: '/reports', icon: 'reports' },
    { label: 'Companies', path: '/companies', icon: 'business' },
    { label: 'Users', path: '/users', icon: 'people' },
    { label: 'Customers', path: '/customers', icon: 'person' },
    { label: 'Items', path: '/items', icon: 'inventory' },
    { label: 'Sales', path: '/sales', icon: 'shopping_cart' },
    { label: 'Debts', path: '/debts', icon: 'receipt' },
    { label: 'Expenses', path: '/expenses', icon: 'expense' },
    { label: 'Help', path: '/help', icon: 'help' },
  ],
  COMPANY_ADMIN: [
    { label: 'Dashboard', path: '/dashboard', icon: 'dashboard' },
    { label: 'Reports', path: '/reports', icon: 'reports' },
    { label: 'Users', path: '/users', icon: 'people' },
    { label: 'Customers', path: '/customers', icon: 'person' },
    { label: 'Items', path: '/items', icon: 'inventory' },
    { label: 'Sales', path: '/sales', icon: 'shopping_cart' },
    { label: 'Debts', path: '/debts', icon: 'receipt' },
    { label: 'Expenses', path: '/expenses', icon: 'expense' },
    { label: 'Help', path: '/help', icon: 'help' },
  ],
  EMPLOYEE: [
    { label: 'Dashboard', path: '/dashboard', icon: 'dashboard' },
    { label: 'Reports', path: '/reports', icon: 'reports' },
    { label: 'Customers', path: '/customers', icon: 'person' },
    { label: 'Items', path: '/items', icon: 'inventory' },
    { label: 'Sales', path: '/sales', icon: 'shopping_cart' },
    { label: 'Debts', path: '/debts', icon: 'receipt' },
    { label: 'Help', path: '/help', icon: 'help' },
  ],
} as const;
